<template>
  <q-page-container>
    <q-page class="">
      <section class="q-px-md q-py-lg flex column">
        <div class="header-page">
          <h4>Opcoes de atendimento</h4>

          <p>Selecio o tipo de atendimento desejado:</p>
        </div>
        <div class="q-py-md options-list">
          <div
            v-if="!optionsList.length"
            class="col-12 full-height flex justify-center items-center"
          >
            <q-circular-progress
              indeterminate
              rounded
              size="60px"
              color="red"
              class="q-ma-md"
            />
          </div>
          <div
            class="option-items"
            v-else
            v-for="item in optionsList"
            :key="item.id_opcao_atendimento"
          >
            <q-btn
              rounded
              class="q-my-sm full-width"
              color="red-9"
              :label="item.opcao"
              @click="redirectRouterAttendace(item)"
              no-caps
            />
          </div>
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
  import LowProductionServices from "@/services/LowProductionServices";
import { IMEDIATAR_OS } from "@/utils/constants/typeAttendance";
import {
  OS_ADESAO_SERVICO,
  OS_MANUTENCAO,
} from "@/utils/constants/typeOs/immediateOs";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

  export default {
    name: "GenerateOs",
    components: {},
    setup() {
      const router = useRouter();
      const route = useRoute();

      const lowProductionServices = new LowProductionServices();
      const attendanceIds = [OS_ADESAO_SERVICO, OS_MANUTENCAO];
      let optionsList = ref([]);

      function redirectRouterAttendace(item) {
        router.push({
          name: "create-os",
          params: { os_type: item.id_opcao_atendimento, name_type: item.opcao },
        });
      }

      async function getServiceOptionList() {
        const response = await lowProductionServices.getServiceOptionList();
        optionsList.value = response;

        const filterCondition =
          Number(route.query.type_attendance) === IMEDIATAR_OS
            ? (item) => attendanceIds.includes(item.id_opcao_atendimento)
            : (item) => !attendanceIds.includes(item.id_opcao_atendimento);

        optionsList.value = optionsList.value.filter(filterCondition);
        
        
      }

      onMounted(() => {
        getServiceOptionList();
      });

      return {
        optionsList,
        redirectRouterAttendace,
      };
    },
  };
</script>

<style lang="scss" scoped>
  section {
    display: flex;
    height: 100vh;
    width: 100vw;
  }

  .header-page {
    h4 {
      font-size: 1rem;
      font-weight: 700;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: left;
      color: red;
      margin: 0;
    }

    p {
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: left;
      color: grey;
      margin: 0;
    }
  }

  .options-list {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
  }

  .option-items {
    display: flex;
    width: 100%;
  }
</style>
